




























import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { GrantData, GrantSummary, ProgressSummary } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";

@Component
export default class PerformanceSummaryComponent extends Vue {

    @Prop() reports: Array<ProgressSummary>;
    @Prop() items: Array<any>;

}
